import { render, staticRenderFns } from "./adesioneMobile.vue?vue&type=template&id=d6d7e2ca&scoped=true&"
import script from "./adesioneMobile.vue.ts?vue&type=script&lang=ts&"
export * from "./adesioneMobile.vue.ts?vue&type=script&lang=ts&"
import style0 from "./adesioneMobile.vue?vue&type=style&index=0&id=d6d7e2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d7e2ca",
  null
  
)

export default component.exports